import React from 'react';
import { Archive, Download } from 'lucide-react';

const DocumentosTab: React.FC = () => {
  // Função para calcular datas (simplificada para este componente)
  const calcularDatas = (dataTermino: string) => {
    const termino = new Date(dataTermino);
    const datas: any = {};
    
    datas.formacaoComissao = new Date(termino.getTime() - (60 * 24 * 60 * 60 * 1000));
    datas.comunicacaoSindicato = new Date(termino.getTime() - (55 * 24 * 60 * 60 * 1000));
    datas.edital = new Date(termino.getTime() - (50 * 24 * 60 * 60 * 1000));
    datas.inicioInscricoes = new Date(termino.getTime() - (45 * 24 * 60 * 60 * 1000));
    datas.terminoInscricoes = new Date(termino.getTime() - (27 * 24 * 60 * 60 * 1000));
    datas.publicacaoLista = new Date(termino.getTime() - (26 * 24 * 60 * 60 * 1000));
    datas.eleicao = new Date(termino.getTime() - (31 * 24 * 60 * 60 * 1000));
    datas.apuracao = new Date(termino.getTime() - (30 * 24 * 60 * 60 * 1000));
    datas.inicioTreinamento = new Date(termino.getTime() - (15 * 24 * 60 * 60 * 1000));
    datas.posse = new Date(termino.getTime() + (1 * 24 * 60 * 60 * 1000));
    
    return datas;
  };

  const dataTerminoMandato = '2025-10-16';
  const datas = calcularDatas(dataTerminoMandato);

  const formatarDataSimples = (data: Date) => {
    return data.toLocaleDateString('pt-BR');
  };

  const modelosDocumentos = {
    'edital-convocacao': {
      nome: 'Edital de Convocação para Eleições',
      conteudo: `EDITAL DE CONVOCAÇÃO PARA ELEIÇÕES DA CIPA

A [NOME DA EMPRESA], inscrita no CNPJ sob nº [CNPJ], com sede na [ENDEREÇO], em cumprimento ao disposto na Norma Regulamentadora nº 05 (NR-05), do Ministério do Trabalho e Previdência, CONVOCA todos os empregados para participarem do processo eleitoral da Comissão Interna de Prevenção de Acidentes e de Assédio - CIPA.

CRONOGRAMA DO PROCESSO ELEITORAL:

Data de início das inscrições: ${formatarDataSimples(datas.inicioInscricoes)}
Data de término das inscrições: ${formatarDataSimples(datas.terminoInscricoes)}
Data da eleição: ${formatarDataSimples(datas.eleicao)}
Data da posse: ${formatarDataSimples(datas.posse)}

Base Legal: NR-05, Arts. 5.5.1 a 5.5.8 - Portaria MTP nº 4.219/2022`
    },
    'ata-formacao-comissao': {
      nome: 'Ata de Formação da Comissão Eleitoral',
      conteudo: `ATA DE FORMAÇÃO DA COMISSÃO ELEITORAL DA CIPA

Aos ${new Date().getDate()} dias do mês de ${new Date().toLocaleDateString('pt-BR', { month: 'long' })} de ${new Date().getFullYear()}, na sede da empresa [NOME DA EMPRESA], reuniram-se os membros da CIPA para constituir a Comissão Eleitoral.

CRONOGRAMA APROVADO:
Publicação do Edital: ${formatarDataSimples(datas.edital)}
Período de Inscrições: ${formatarDataSimples(datas.inicioInscricoes)} a ${formatarDataSimples(datas.terminoInscricoes)}
Data da Eleição: ${formatarDataSimples(datas.eleicao)}
Data da Posse: ${formatarDataSimples(datas.posse)}

Base Legal: Art. 5.5.2 da NR-05 - Portaria MTP nº 4.219/2022`
    },
    'comunicacao-sindicato': {
      nome: 'Comunicação ao Sindicato',
      conteudo: `COMUNICAÇÃO DE INÍCIO DO PROCESSO ELEITORAL DA CIPA

Para: [NOME DO SINDICATO DA CATEGORIA PREPONDERANTE]
De: [NOME DA EMPRESA]
Data: ${new Date().toLocaleDateString('pt-BR')}

Comunicamos o início do processo eleitoral da CIPA.

Cronograma:
Término do mandato atual: ${formatarDataSimples(new Date(dataTerminoMandato))}
Início das inscrições: ${formatarDataSimples(datas.inicioInscricoes)}
Término das inscrições: ${formatarDataSimples(datas.terminoInscricoes)}
Data da eleição: ${formatarDataSimples(datas.eleicao)}
Data da posse: ${formatarDataSimples(datas.posse)}

Base Legal: Art. 5.5.1.1 da NR-05`
    },
    'lista-candidatos': {
      nome: 'Lista de Candidatos Inscritos',
      conteudo: `RELAÇÃO DOS CANDIDATOS INSCRITOS
ELEIÇÕES DA CIPA - GESTÃO ${new Date().getFullYear()}/${new Date().getFullYear() + 1}

Empresa: [NOME DA EMPRESA]
CNPJ: [CNPJ]

Período de Inscrições: ${formatarDataSimples(datas.inicioInscricoes)} a ${formatarDataSimples(datas.terminoInscricoes)}
Data da Eleição: ${formatarDataSimples(datas.eleicao)}

CANDIDATOS INSCRITOS:
[LISTA DE CANDIDATOS]

Base Legal: Art. 5.5.3, alínea "e" da NR-05`
    },
    'ata-eleicao-apuracao': {
      nome: 'Ata de Eleição e Apuração',
      conteudo: `ATA DE ELEIÇÃO E APURAÇÃO DA CIPA

Aos ${formatarDataSimples(datas.eleicao).split('/')[0]} dias do mês de ${new Date(datas.eleicao).toLocaleDateString('pt-BR', { month: 'long' })} de ${new Date(datas.eleicao).getFullYear()}, realizou-se a eleição para escolha dos representantes dos empregados na CIPA.

RESULTADO DA ELEIÇÃO:
[INSERIR RANKING DOS CANDIDATOS]

Base Legal: Art. 5.5.3, alínea "i" e Arts. 5.5.6 a 5.5.8 da NR-05`
    },
    'ata-posse': {
      nome: 'Ata de Posse dos Membros',
      conteudo: `ATA DE POSSE DOS MEMBROS DA CIPA
GESTÃO ${new Date().getFullYear()}/${new Date().getFullYear() + 1}

Aos ${formatarDataSimples(datas.posse).split('/')[0]} dias do mês de ${new Date(datas.posse).toLocaleDateString('pt-BR', { month: 'long' })} de ${new Date(datas.posse).getFullYear()}, realizou-se a posse dos membros da CIPA.

Mandato: ${formatarDataSimples(datas.posse)} a ${formatarDataSimples(new Date(datas.posse.getTime() + (365 * 24 * 60 * 60 * 1000)))}

Base Legal: Art. 5.4.7 da NR-05`
    }
  };

  const checklistsConformidade = {
    'processo-eleitoral': {
      nome: 'Checklist Processo Eleitoral',
      conteudo: `CHECKLIST DE CONFORMIDADE - PROCESSO ELEITORAL DA CIPA
Baseado na NR-05 vigente (Portaria MTP nº 4.219/2022)

EMPRESA: _________________________________ CNPJ: _________________
GESTÃO: ${new Date().getFullYear()}/${new Date().getFullYear() + 1}
DATA DE VERIFICAÇÃO: ___/___/_____

════════════════════════════════════════════════════════════════

1. CONVOCAÇÃO DAS ELEIÇÕES
□ Convocação realizada no prazo mínimo de 60 dias antes do término do mandato (Art. 5.5.1)
□ Data da convocação: ___/___/_____
□ Data término mandato atual: ${formatarDataSimples(new Date(dataTerminoMandato))}
□ Prazo respeitado: _____ dias de antecedência

2. COMUNICAÇÃO AO SINDICATO  
□ Comunicação enviada com antecedência (Art. 5.5.1.1)
□ Meio eletrônico utilizado com confirmação de entrega
□ Data do envio: ___/___/_____
□ Comprovante de entrega obtido
□ Protocolo/recibo: ________________

3. FORMAÇÃO DA COMISSÃO ELEITORAL
□ Comissão constituída entre membros da CIPA atual (Art. 5.5.2)
□ Presidente nomeado: ________________________________
□ Secretário nomeado: _______________________________
□ Ata de formação elaborada
□ Data de formação: ___/___/_____

4. EDITAL DE CONVOCAÇÃO
□ Edital publicado e divulgado (Art. 5.5.3a)
□ Locais de fácil acesso e visualização utilizados
□ Meio físico disponibilizado
□ Meio eletrônico disponibilizado
□ Data de publicação: ___/___/_____

5. PERÍODO DE INSCRIÇÕES
□ Período mínimo de 15 dias corridos respeitado (Art. 5.5.3b)
□ Data início: ${formatarDataSimples(datas.inicioInscricoes)}
□ Data término: ${formatarDataSimples(datas.terminoInscricoes)}
□ Total de dias: 18 dias (superior ao mínimo legal)
□ Inscrições individuais recebidas
□ Comprovantes de inscrição fornecidos

6. ELEIÇÃO E APURAÇÃO
□ Eleição no mínimo 30 dias antes do término do mandato (Art. 5.5.3f)
□ Data da eleição: ${formatarDataSimples(datas.eleicao)}
□ Voto secreto garantido (Art. 5.5.3h)
□ Apuração em horário normal (Art. 5.5.3i)
□ Sistema seguro utilizado (Art. 5.5.3j)

RESUMO DE CONFORMIDADE:
Total de itens: 24
Itens conformes: ___/24
Percentual: ____%

Base Legal: NR-05 - Portaria MTP nº 4.219/2022`
    },
    'documentacao-legal': {
      nome: 'Checklist Documentação Legal',
      conteudo: `CHECKLIST DE CONFORMIDADE - DOCUMENTAÇÃO LEGAL DA CIPA
Baseado na NR-05 vigente (Portaria MTP nº 4.219/2022)

EMPRESA: _________________________________ CNPJ: _________________
DATA DE VERIFICAÇÃO: ___/___/_____

════════════════════════════════════════════════════════════════

1. DOCUMENTAÇÃO DO PROCESSO ELEITORAL
□ Ata de formação da comissão eleitoral arquivada
□ Edital de convocação original mantido
□ Lista de candidatos inscritos com comprovantes
□ Ata de eleição e apuração completa
□ Ata de posse dos novos membros
□ Comunicação ao sindicato com comprovante

2. CÓPIAS OBRIGATÓRIAS (Art. 5.4.8)
□ Cópias das atas de eleição fornecidas aos titulares
□ Cópias das atas de posse fornecidas aos titulares
□ Cópias das atas de eleição fornecidas aos suplentes
□ Cópias das atas de posse fornecidas aos suplentes
□ Recibos de entrega das cópias aos membros

3. DOCUMENTAÇÃO DE FUNCIONAMENTO
□ Calendário de reuniões ordinárias estabelecido (Art. 5.6.1)
□ Atas de reuniões mensais arquivadas (Art. 5.6.3)
□ Atas assinadas pelos presentes
□ Atas disponibilizadas a todos integrantes (Art. 5.6.3.1)
□ Deliberações disponibilizadas aos empregados (Art. 5.6.3.2)

4. DOCUMENTAÇÃO DO TREINAMENTO
□ Certificados de treinamento de todos os membros (Art. 5.7.1)
□ Carga horária conforme grau de risco (Art. 5.7.4)
□ Conteúdo programático arquivado (Art. 5.7.2)
□ Treinamento incluindo combate ao assédio (Art. 5.7.2h)
□ Treinamento realizado antes da posse

5. ARQUIVO E RETENÇÃO (Art. 5.9.2)
□ Documentação mantida no estabelecimento
□ Prazo mínimo de 5 anos para arquivo respeitado
□ Sistema de arquivo organizado
□ Acesso para inspeção garantido

RESUMO DE CONFORMIDADE:
Total de itens: 22
Itens conformes: ___/22
Percentual: ____%

Base Legal: NR-05 - Portaria MTP nº 4.219/2022`
    },
    'comunicacoes-obrigatorias': {
      nome: 'Checklist Comunicações Obrigatórias',
      conteudo: `CHECKLIST DE CONFORMIDADE - COMUNICAÇÕES OBRIGATÓRIAS DA CIPA
Baseado na NR-05 vigente (Portaria MTP nº 4.219/2022)

EMPRESA: _________________________________ CNPJ: _________________
DATA DE VERIFICAÇÃO: ___/___/_____

════════════════════════════════════════════════════════════════

1. COMUNICAÇÃO PRÉ-ELEITORAL AO SINDICATO
□ Comunicação de início enviada com antecedência (Art. 5.5.1.1)
□ Meio eletrônico com confirmação utilizado
□ Data do envio: ___/___/_____
□ Sindicato da categoria preponderante identificado
□ Dados completos da empresa incluídos

2. INFORMAÇÕES NA COMUNICAÇÃO INICIAL
□ Razão social da empresa
□ CNPJ da empresa
□ Endereço completo
□ Data de término do mandato atual
□ Cronograma do processo eleitoral
□ Número total de empregados
□ Grau de risco da empresa

3. COMUNICAÇÃO DE PRORROGAÇÕES
□ Prorrogação por participação < 50% comunicada (Art. 5.5.4.2)
□ Prorrogação por participação < 1/3 comunicada (Art. 5.5.4.2)
□ Justificativas documentadas
□ Nova data informada ao sindicato

4. DIVULGAÇÃO INTERNA
□ Edital publicado em locais de fácil acesso (Art. 5.5.3a)
□ Lista de candidatos divulgada (Art. 5.5.3e)
□ Meio físico utilizado
□ Meio eletrônico utilizado
□ Visualização facilitada garantida

5. COMUNICAÇÃO DE DELIBERAÇÕES
□ Deliberações disponibilizadas a todos empregados (Art. 5.6.3.2)
□ Quadro de avisos utilizado
□ Meio eletrônico utilizado
□ Linguagem acessível utilizada

6. DOCUMENTAÇÃO ENVIADA AO SINDICATO
□ Processo enviado no prazo de 10 dias (Art. 5.4.9)
□ Meio eletrônico utilizado (quando aplicável)
□ Todos os documentos incluídos
□ Comprovante de entrega mantido

RESUMO DE CONFORMIDADE:
Total de itens: 25
Itens conformes: ___/25
Percentual: ____%

Base Legal: NR-05 - Portaria MTP nº 4.219/2022`
    },
    'treinamento-obrigatorio': {
      nome: 'Checklist Treinamento Obrigatório',
      conteudo: `CHECKLIST DE CONFORMIDADE - TREINAMENTO OBRIGATÓRIO DA CIPA
Baseado na NR-05 vigente (Portaria MTP nº 4.219/2022)

EMPRESA: _________________________________ CNPJ: _________________
GRAU DE RISCO: _____ DATA DE VERIFICAÇÃO: ___/___/_____

════════════════════════════════════════════════════════════════

1. PLANEJAMENTO DO TREINAMENTO
□ Treinamento programado antes da posse (Art. 5.7.1)
□ Prazo máximo de 30 dias após posse respeitado (Art. 5.7.1.1)
□ Data da posse: ${formatarDataSimples(datas.posse)}
□ Data limite: ${formatarDataSimples(new Date(datas.posse.getTime() + (30 * 24 * 60 * 60 * 1000)))}
□ Instrutor qualificado selecionado
□ Local adequado reservado

2. PARTICIPANTES
□ Todos os membros titulares incluídos
□ Todos os membros suplentes incluídos
□ Representante nomeado da NR-05 incluído (quando aplicável)
□ Lista de presença preparada

3. CARGA HORÁRIA CONFORME GRAU DE RISCO (Art. 5.7.4)
□ Grau de risco 1: 8 horas mínimas
□ Grau de risco 2: 12 horas mínimas  
□ Grau de risco 3: 16 horas mínimas
□ Grau de risco 4: 20 horas mínimas
□ Distribuição máxima de 8 horas diárias (Art. 5.7.4.1)

4. MODALIDADE DE ENSINO (Art. 5.7.4.2)
Para grau de risco 2:
□ Mínimo 4 horas presenciais
□ Restante EAD/semipresencial permitido

Para graus de risco 3 e 4:
□ Mínimo 8 horas presenciais
□ Restante EAD/semipresencial permitido

5. CONTEÚDO OBRIGATÓRIO (Art. 5.7.2)
□ Estudo do ambiente e condições de trabalho (Art. 5.7.2a)
□ Acidentes e doenças do trabalho (Art. 5.7.2b)
□ Metodologia de investigação (Art. 5.7.2c)
□ Princípios de higiene e prevenção (Art. 5.7.2d)
□ Legislação trabalhista e previdenciária (Art. 5.7.2e)
□ Inclusão e reabilitação (Art. 5.7.2f)
□ Organização da CIPA (Art. 5.7.2g)
□ Prevenção ao assédio e violência (Art. 5.7.2h)

6. DOCUMENTAÇÃO DO TREINAMENTO
□ Lista de presença assinada
□ Conteúdo programático arquivado
□ Certificados emitidos
□ Avaliação realizada
□ Material didático registrado

RESUMO DE CONFORMIDADE:
Total de itens: 28
Itens conformes: ___/28
Percentual: ____%

Base Legal: NR-05 - Portaria MTP nº 4.219/2022`
    },
    'posse-inicio-mandato': {
      nome: 'Checklist Posse e Início do Mandato',
      conteudo: `CHECKLIST DE CONFORMIDADE - POSSE E INÍCIO DO MANDATO DA CIPA
Baseado na NR-05 vigente (Portaria MTP nº 4.219/2022)

EMPRESA: _________________________________ CNPJ: _________________
GESTÃO: ${new Date().getFullYear()}/${new Date().getFullYear() + 1}
DATA DE VERIFICAÇÃO: ___/___/_____

════════════════════════════════════════════════════════════════

1. CRONOLOGIA DO PROCESSO
□ Término do mandato anterior: ${formatarDataSimples(new Date(dataTerminoMandato))}
□ Data da posse: ${formatarDataSimples(datas.posse)}
□ Posse no primeiro dia útil confirmada (Art. 5.4.7)
□ Continuidade dos trabalhos garantida

2. COMPOSIÇÃO DA NOVA CIPA
□ Dimensionamento conforme Quadro I respeitado (Art. 5.4.1)
□ Representantes da organização designados (Art. 5.4.3)
□ Representantes dos empregados eleitos (Art. 5.4.4)
□ Proporção entre representantes respeitada

3. ELEIÇÃO DOS DIRIGENTES
□ Presidente designado pela organização (Art. 5.4.5)
□ Vice-presidente escolhido entre eleitos (Art. 5.4.5)
□ Processo de escolha documentado
□ Comunicação das designações realizada

4. DOCUMENTAÇÃO DA POSSE
□ Ata de posse elaborada e assinada
□ Todos os membros empossados presentes
□ Mandato de dois anos definido (Art. 5.4.6)
□ Período especificado: ___/___/_____ a ___/___/_____

5. FORNECIMENTO DE CÓPIAS (Art. 5.4.8)
□ Cópias das atas fornecidas aos titulares
□ Cópias das atas fornecidas aos suplentes
□ Recibos de entrega obtidos
□ Arquivo organizado

6. ESTABELECIMENTO DO FUNCIONAMENTO
□ Calendário mensal estabelecido (Art. 5.6.1)
□ Datas acordadas entre membros (Art. 5.6.2.1)
□ Turnos e jornadas considerados
□ Local das reuniões definido

7. PLANO DE TRABALHO (Art. 5.3.1d)
□ Plano de ação preventiva elaborado
□ Cronograma de atividades definido
□ Metas e objetivos estabelecidos
□ Responsabilidades distribuídas

8. GARANTIAS E PROTEÇÕES
□ Estabilidade no emprego esclarecida (Art. 5.4.12)
□ Proteção desde candidatura até 2 anos após mandato
□ Vedações à organização explicadas (Art. 5.4.11)
□ Direitos dos membros esclarecidos

9. COMUNICAÇÃO AO SINDICATO PÓS-POSSE
□ Resultado final comunicado
□ Composição informada
□ Data de início comunicada
□ Comprovante obtido

RESUMO DE CONFORMIDADE:
Total de itens: 32
Itens conformes: ___/32
Percentual: ____%

Base Legal: NR-05 - Portaria MTP nº 4.219/2022`
    }
  };

  const baixarDocumento = (tipoDoc: string) => {
    const documento = modelosDocumentos[tipoDoc as keyof typeof modelosDocumentos];
    if (!documento) return;

    const blob = new Blob([documento.conteudo], { type: 'text/plain;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${documento.nome.replace(/\s+/g, '_')}_${new Date().toLocaleDateString('pt-BR').replace(/\//g, '')}.txt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const baixarChecklist = (tipoChecklist: string) => {
    const checklist = checklistsConformidade[tipoChecklist as keyof typeof checklistsConformidade];
    if (!checklist) return;

    const blob = new Blob([checklist.conteudo], { type: 'text/plain;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${checklist.nome.replace(/\s+/g, '_')}_${new Date().toLocaleDateString('pt-BR').replace(/\//g, '')}.txt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  // Função para visualizar NR-05 completa
  const visualizarNR05Completa = () => {
    const nr05Completa = `NORMA REGULAMENTADORA Nº 05 (NR-05)
COMISSÃO INTERNA DE PREVENÇÃO DE ACIDENTES E DE ASSÉDIO - CIPA

PORTARIA MTP Nº 4.219/2022

════════════════════════════════════════════════════════════════

CAPÍTULO I - DISPOSIÇÕES GERAIS

Art. 5.1 - Objetivo
A Comissão Interna de Prevenção de Acidentes e de Assédio - CIPA tem como objetivo a prevenção de acidentes e doenças decorrentes do trabalho, de modo a tornar compatível permanentemente o trabalho com a preservação da vida e a promoção da saúde do trabalhador.

Art. 5.2 - Constituição
A CIPA será constituída por representantes do empregador e dos empregados, de acordo com o dimensionamento previsto no Quadro I, observando-se os casos previstos nos Arts. 5.2.1 a 5.2.3.

Art. 5.3 - Atribuições da CIPA
A CIPA terá por atribuição:
a) identificar os riscos do processo de trabalho, e elaborar o mapa de riscos, com a participação do maior número de trabalhadores, com assessoria do SESMT, onde houver;
b) elaborar plano de trabalho que possibilite a ação preventiva na solução de problemas de segurança e saúde no trabalho;
c) participar da implementação e do controle da qualidade das medidas de prevenção necessárias, bem como da avaliação das prioridades de ação nos locais de trabalho;
d) realizar, periodicamente, verificações nos ambientes e condições de trabalho visando a identificação de situações que possam trazer riscos para a segurança e saúde dos trabalhadores;
e) realizar, a cada reunião ordinária, avaliação do cumprimento das metas fixadas em seu plano de trabalho e discutir as situações de risco que foram identificadas;
f) participar de reuniões ordinárias do empregador, quando convocada;
g) participar, quando convocada, das reuniões de negociação coletiva de trabalho, quando a pauta incluir matéria relacionada à segurança e saúde no trabalho;
h) participar de campanhas de promoção da saúde, desenvolvidas no local de trabalho;
i) promover, anualmente, em conjunto com o SESMT, onde houver, a Semana Interna de Prevenção de Acidentes do Trabalho - SIPAT;
j) participar, anualmente, da elaboração da programação de treinamento dos membros da CIPA;
k) fazer constar das atas de reunião, as decisões tomadas pela comissão;
l) encaminhar ao empregador e ao SESMT, onde houver, as solicitações de melhorias nas condições de trabalho, bem como sugestões para o desenvolvimento de ações de prevenção de acidentes e doenças decorrentes do trabalho;
m) divulgar aos trabalhadores informações sobre saúde e segurança no trabalho;
n) participar da análise das causas das doenças e acidentes de trabalho e colaborar na elaboração de estatísticas que possibilitem estudos e melhoria das medidas de segurança;
o) requisitar ao empregador e analisar as informações sobre questões que tenham interferido na segurança e saúde dos trabalhadores;
p) requisitar à empresa as cópias das CAT emitidas;
q) promover, anualmente, juntamente com o SESMT, onde houver, a realização de exercício simulado de abandono do local de trabalho;
r) participar das reuniões mensais do SESMT, onde houver;
s) participar de reuniões extraordinárias do empregador, quando convocada;
t) participar de reuniões de negociação coletiva de trabalho, quando convocada e quando a pauta incluir matéria relacionada à segurança e saúde no trabalho;
u) participar de campanhas de promoção da saúde, desenvolvidas no local de trabalho;
v) participar da análise das causas das doenças e acidentes de trabalho e colaborar na elaboração de estatísticas que possibilitem estudos e melhoria das medidas de segurança;
w) requisitar ao empregador e analisar as informações sobre questões que tenham interferido na segurança e saúde dos trabalhadores;
x) requisitar à empresa as cópias das CAT emitidas;
y) promover, anualmente, juntamente com o SESMT, onde houver, a realização de exercício simulado de abandono do local de trabalho;
z) participar das reuniões mensais do SESMT, onde houver.

════════════════════════════════════════════════════════════════

CAPÍTULO II - PROCESSO ELEITORAL

Art. 5.5 - Convocação das Eleições
Art. 5.5.1 - A organização deve convocar as eleições da CIPA no prazo mínimo de 60 (sessenta) dias antes do término do mandato atual.

Art. 5.5.1.1 - A organização deve comunicar, com antecedência, por meio eletrônico com confirmação de entrega, ao sindicato da categoria preponderante, o início do processo eleitoral da CIPA.

Art. 5.5.2 - A comissão eleitoral será constituída entre os membros da CIPA atual, sendo designado presidente e secretário.

Art. 5.5.3 - O processo eleitoral deve observar:
a) a publicação do edital de convocação em locais de fácil acesso e visualização, em meio físico ou eletrônico;
b) a abertura de prazos para inscrições individuais de todos os empregados, com período mínimo de 15 (quinze) dias corridos, com fornecimento de comprovante de inscrição;
c) a garantia de liberdade de inscrição independente de setor;
d) a garantia de estabilidade de emprego para todos os inscritos;
e) a publicação da relação completa dos empregados inscritos em locais de fácil acesso e visualização, em meio físico ou eletrônico;
f) a realização da eleição em dia normal de trabalho, no mínimo 30 (trinta) dias antes do término do mandato atual;
g) a realização da eleição em horários que permitam a participação da maioria dos empregados, respeitando os turnos de trabalho;
h) a garantia de voto secreto;
i) a apuração em horário normal de trabalho, permitindo acompanhamento de representantes da organização e empregados, facultando o acompanhamento dos candidatos;
j) a utilização de sistema que garanta segurança e confidencialidade.

════════════════════════════════════════════════════════════════

CAPÍTULO III - TREINAMENTO

Art. 5.7 - Treinamento
Art. 5.7.1 - A organização deve promover treinamento para os membros titulares e suplentes da CIPA, antes da posse, com carga horária mínima conforme o grau de risco da atividade, conforme Quadro II.

Art. 5.7.1.1 - O treinamento deve ser realizado no prazo máximo de 30 (trinta) dias após a posse.

Art. 5.7.2 - O treinamento deve abordar:
a) estudo do ambiente, das condições de trabalho, bem como dos riscos originados do processo produtivo;
b) metodologia de investigação e análise de acidentes e doenças do trabalho;
c) noções sobre acidentes e doenças do trabalho, incluindo os aspectos atinentes à saúde ocupacional;
d) noções sobre as legislações trabalhista e previdenciária relacionadas à segurança e saúde no trabalho;
e) princípios gerais de higiene do trabalho e de medidas de controle dos riscos;
f) organização da CIPA e outros assuntos necessários ao exercício das atribuições da comissão;
g) noções sobre a inclusão e reabilitação de trabalhadores com deficiência;
h) noções sobre prevenção e combate ao assédio sexual e à violência no trabalho.

════════════════════════════════════════════════════════════════

QUADRO I - DIMENSIONAMENTO DA CIPA

Grau de Risco | Até 500 empregados | 501 a 1.000 | 1.001 a 2.000 | 2.001 a 3.500 | 3.501 a 5.000 | Acima de 5.000
1            | 1 titular + 1 suplente | 2 titulares + 2 suplentes | 3 titulares + 3 suplentes | 4 titulares + 4 suplentes | 5 titulares + 5 suplentes | 6 titulares + 6 suplentes
2            | 1 titular + 1 suplente | 2 titulares + 2 suplentes | 3 titulares + 3 suplentes | 4 titulares + 4 suplentes | 5 titulares + 5 suplentes | 6 titulares + 6 suplentes
3            | 1 titular + 1 suplente | 2 titulares + 2 suplentes | 3 titulares + 3 suplentes | 4 titulares + 4 suplentes | 5 titulares + 5 suplentes | 6 titulares + 6 suplentes
4            | 1 titular + 1 suplente | 2 titulares + 2 suplentes | 3 titulares + 3 suplentes | 4 titulares + 4 suplentes | 5 titulares + 5 suplentes | 6 titulares + 6 suplentes

════════════════════════════════════════════════════════════════

QUADRO II - CARGA HORÁRIA MÍNIMA DO TREINAMENTO

Grau de Risco | Carga Horária Mínima
1            | 8 horas
2            | 12 horas
3            | 16 horas
4            | 20 horas

════════════════════════════════════════════════════════════════

Base Legal: Portaria MTP nº 4.219/2022 - Publicada no DOU em 22/12/2022
Vigência: A partir de 22/12/2022`;

    // Abrir em nova janela
    const newWindow = window.open('', '_blank', 'width=800,height=600,scrollbars=yes');
    if (newWindow) {
      newWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>NR-05 Completa</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; line-height: 1.6; }
            h1 { color: #2563eb; border-bottom: 2px solid #2563eb; padding-bottom: 10px; }
            h2 { color: #1e40af; margin-top: 30px; }
            .separator { border-top: 1px solid #ccc; margin: 20px 0; }
            pre { white-space: pre-wrap; font-family: inherit; }
          </style>
        </head>
        <body>
          <pre>${nr05Completa}</pre>
        </body>
        </html>
      `);
      newWindow.document.close();
    }
  };

  // Função para baixar resumo dos artigos aplicáveis
  const baixarResumoArtigos = () => {
    const resumoArtigos = `RESUMO DOS ARTIGOS APLICÁVEIS - NR-05
PROCESSO ELEITORAL DA CIPA

════════════════════════════════════════════════════════════════

ARTIGOS PRINCIPAIS PARA O PROCESSO ELEITORAL:

1. CONVOCAÇÃO DAS ELEIÇÕES
Art. 5.5.1 - Convocação no prazo mínimo de 60 dias antes do término do mandato
Art. 5.5.1.1 - Comunicação ao sindicato com antecedência

2. FORMAÇÃO DA COMISSÃO ELEITORAL
Art. 5.5.2 - Constituição entre membros da CIPA atual

3. PROCESSO ELEITORAL
Art. 5.5.3(a) - Publicação do edital de convocação
Art. 5.5.3(b) - Período mínimo de 15 dias para inscrições
Art. 5.5.3(c) - Liberdade de inscrição independente de setor
Art. 5.5.3(d) - Garantia de estabilidade de emprego
Art. 5.5.3(e) - Publicação da lista de candidatos
Art. 5.5.3(f) - Eleição no mínimo 30 dias antes do término
Art. 5.5.3(g) - Horários que permitam participação da maioria
Art. 5.5.3(h) - Garantia de voto secreto
Art. 5.5.3(i) - Apuração em horário normal de trabalho
Art. 5.5.3(j) - Sistema que garanta segurança e confidencialidade

4. TREINAMENTO OBRIGATÓRIO
Art. 5.7.1 - Treinamento antes da posse
Art. 5.7.1.1 - Prazo máximo de 30 dias após a posse
Art. 5.7.2 - Conteúdo obrigatório do treinamento

5. ATRIBUIÇÕES DA CIPA
Art. 5.3 - Lista completa das atribuições

6. DIMENSIONAMENTO
Quadro I - Dimensionamento conforme grau de risco e número de empregados

7. CARGA HORÁRIA DO TREINAMENTO
Quadro II - Carga horária mínima conforme grau de risco

════════════════════════════════════════════════════════════════

PRAZOS CRÍTICOS:

• Convocação: 60 dias antes do término do mandato
• Inscrições: Mínimo 15 dias corridos
• Eleição: Mínimo 30 dias antes do término
• Treinamento: Antes da posse (máx. 30 dias após)

════════════════════════════════════════════════════════════════

DOCUMENTAÇÃO OBRIGATÓRIA:

• Ata de formação da comissão eleitoral
• Edital de convocação
• Lista de candidatos inscritos
• Ata de eleição e apuração
• Ata de posse
• Comunicação ao sindicato
• Certificados de treinamento

════════════════════════════════════════════════════════════════

Base Legal: Portaria MTP nº 4.219/2022
Data de Geração: ${new Date().toLocaleDateString('pt-BR')}`;

    const blob = new Blob([resumoArtigos], { type: 'text/plain;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `Resumo_Artigos_NR05_${new Date().toLocaleDateString('pt-BR').replace(/\//g, '')}.txt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-lg p-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-3">
          <Archive className="text-blue-600" />
          Documentos e Modelos
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <div className="bg-blue-50 p-6 rounded-lg">
            <h3 className="font-bold text-blue-800 mb-4">Modelos Obrigatórios</h3>
            <div className="space-y-3">
              {Object.keys(modelosDocumentos).map((key) => (
                <div key={key} className="flex items-center justify-between p-2 bg-white rounded border">
                  <span className="text-sm font-medium">{modelosDocumentos[key as keyof typeof modelosDocumentos].nome}</span>
                  <button 
                    onClick={() => baixarDocumento(key)}
                    className="text-blue-600 hover:text-blue-800 hover:bg-blue-50 p-1 rounded transition-colors"
                    title="Baixar modelo"
                  >
                    <Download className="w-4 h-4" />
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-green-50 p-6 rounded-lg">
            <h3 className="font-bold text-green-800 mb-4">Checklists de Conformidade</h3>
            <div className="space-y-3">
              {[
                { key: 'processo-eleitoral', nome: 'Checklist Processo Eleitoral' },
                { key: 'documentacao-legal', nome: 'Checklist Documentação Legal' },
                { key: 'comunicacoes-obrigatorias', nome: 'Checklist Comunicações Obrigatórias' },
                { key: 'treinamento-obrigatorio', nome: 'Checklist Treinamento Obrigatório' },
                { key: 'posse-inicio-mandato', nome: 'Checklist Posse e Início do Mandato' }
              ].map((checklist) => (
                <div key={checklist.key} className="flex items-center justify-between p-2 bg-white rounded border">
                  <span className="text-sm font-medium">{checklist.nome}</span>
                  <button 
                    onClick={() => baixarChecklist(checklist.key)}
                    className="text-green-600 hover:text-green-800 hover:bg-green-50 p-1 rounded transition-colors"
                    title="Baixar checklist"
                  >
                    <Download className="w-4 h-4" />
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="bg-gray-50 p-6 rounded-lg">
          <h3 className="font-bold text-gray-800 mb-4">Base Legal Completa</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-white p-4 rounded border">
              <h4 className="font-medium text-gray-800 mb-2">NR-05 Vigente</h4>
              <p className="text-sm text-gray-600 mb-3">
                Comissão Interna de Prevenção de Acidentes e de Assédio - CIPA
              </p>
              <button 
                onClick={visualizarNR05Completa}
                className="bg-blue-600 text-white px-3 py-1 rounded text-sm hover:bg-blue-700"
              >
                Visualizar Completa
              </button>
            </div>
            <div className="bg-white p-4 rounded border">
              <h4 className="font-medium text-gray-800 mb-2">Artigos Aplicáveis</h4>
              <p className="text-sm text-gray-600 mb-3">
                Compilação dos artigos específicos para processo eleitoral
              </p>
              <button 
                onClick={baixarResumoArtigos}
                className="bg-green-600 text-white px-3 py-1 rounded text-sm hover:bg-green-700"
              >
                Baixar Resumo
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentosTab;
